// extracted by mini-css-extract-plugin
export var formContainer = "_cg-0";
export var message = "_cg-1";